import React from 'react';
import {ChatIntro} from './ChatIntro';

const SUGGESTION_IDS = [
	'forecast_agent.suggestion.portfolio_health',
	'forecast_agent.suggestion.team_utilisation',
	'forecast_agent.suggestion.projects_at_risk',
	'forecast_agent.suggestion.capacity_next_week',
] as const;

type EmptyStateProps = {
	onSuggestionClick: (text: string) => void;
};

export function EmptyState({onSuggestionClick}: EmptyStateProps): JSX.Element {
	return <ChatIntro bodyId="nova.empty.body" suggestionIds={SUGGESTION_IDS} onSuggestionClick={onSuggestionClick} />;
}
